import { render, staticRenderFns } from "./CPCheckboxAccordion.vue?vue&type=template&id=2766869f&scoped=true&"
import script from "./CPCheckboxAccordion.vue?vue&type=script&lang=ts&"
export * from "./CPCheckboxAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./CPCheckboxAccordion.vue?vue&type=style&index=0&id=2766869f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2766869f",
  null
  
)

export default component.exports